import ActiveRecord from './models/active_record/base'
import PlanningShift from './models/planning_shift'
import TimeRegistrationShift from './models/time_registration_shift'
import WeatherDay from './models/weather_day'
import Event from './models/event'
import EventSeries from './models/event_series'
import RevenueDay from './models/revenue_day'
import RevenueGroup from './models/revenue_group'
import RevenueTeam from './models/revenue_team'
import PlanningTemplate from './models/planning_template'
import BaseConnection from './models/base_connection'
import LeaveRequest from './models/leave_request'
import Allowance from './models/allowance'
import UserWeek from './models/user_week'
import Day from './models/day'
import ContractHolder from './models/contract_holder'
import ShiftType from './models/shift_type'
import Association from './models/active_record/association'
import SickPeriod from './models/sick_period'
import Excel from './models/excel'
import ExportSubscription from './models/export_subscription'
import ExportTable from './models/export_table'
import ExtEnvironment from './models/ext_environment'
import ExtRevenueGroup from './models/ext_revenue_group'
import CheckIn from './models/check_in'
import TradeRequest from './models/trade_request'
import Info from './models/info'
import BillingInfo from './models/billing_info'
import Invoice from './models/invoice'
import Team from './models/team'
import User from './models/user'
import Environment from './models/environment'
import Operation from './models/operation'
import SkillSet from './models/skill_set'
import Topic from './models/topic'
import MailSubscription from './models/mail_subscription'
import Post from './models/post'
import QuizItem from './models/quiz_item'
import EmploymentType from './models/employment_type'
import UserEmploymentType from './models/user_employment_type'
import BalanceAdjustment from './models/balance_adjustment'
import WorkSchedule from './models/work_schedule'
import AvailabilityShift from './models/availability_shift'
import AuthorizedDevice from './models/authorized_device'
import CheckInLocation from './models/check_in_location'
import WorkWeek from './models/work_week'
import {Role} from './models/role'
import TeamTemplateDay from './models/team_template_day'
import TeamDay from './models/team_day'
import Skill from './models/skill'
import Salary from './models/salary'
import AvailabilityTemplateShift from './models/availability_template_shift'
import UserTemplateWeek from './models/user_template_week'
import Organisation from './models/organisation'
import Admin from './models/admin'
import {ApiConsumer} from './models/api_consumer'
import BillingActivity from './models/billing_activity'
import EventType from './models/event_type'

export * from './db_config'
export * from './models/active_record/contract_part'
export * from './permissions'
export * from './scopes'

const modelArray = [
	Organisation,
	AvailabilityTemplateShift,
	Admin,
	ApiConsumer,
	Skill,
	Salary,
	MailSubscription,
	TeamTemplateDay,
	TeamDay,
	AuthorizedDevice,
	CheckInLocation,
	User,
	EmploymentType,
	WorkWeek,
	WorkSchedule,
	BalanceAdjustment,
	UserEmploymentType,
	Event,
	EventSeries,
	EventType,
	UserWeek,
	AvailabilityShift,
	ContractHolder,
	RevenueDay,
	PlanningShift,
	PlanningTemplate,
	LeaveRequest,
	TimeRegistrationShift,
	WeatherDay,
	RevenueGroup,
	SickPeriod,
	RevenueTeam,
	BaseConnection,
	Excel,
	ExportSubscription,
	ExportTable,
	ExtEnvironment,
	Operation,
	ExtRevenueGroup,
	CheckIn,
	TradeRequest,
	Info,
	BillingInfo,
	Invoice,
	Allowance,
	ShiftType,
	Day,
	Team,
	Topic,
	Post,
	QuizItem,
	Environment,
	SkillSet,
	Role,
	UserTemplateWeek,
	BillingActivity,
]

const models = {}
modelArray.forEach(m => (models[m.tableName] = m))

export {
	models,
	Organisation,
	ActiveRecord,
	TeamTemplateDay,
	TeamDay,
	AuthorizedDevice,
	CheckInLocation,
	User,
	AvailabilityTemplateShift,
	UserWeek,
	MailSubscription,
	Association,
	WorkSchedule,
	Role,
	BalanceAdjustment,
	PlanningShift,
	Admin,
	ApiConsumer,
	Skill,
	TimeRegistrationShift,
	PlanningTemplate,
	ContractHolder,
	WeatherDay,
	Salary,
	Event,
	EventSeries,
	EventType,
	RevenueDay,
	LeaveRequest,
	Operation,
	RevenueGroup,
	RevenueTeam,
	SickPeriod,
	AvailabilityShift,
	BaseConnection,
	Excel,
	ExportSubscription,
	ExportTable,
	ExtEnvironment,
	ExtRevenueGroup,
	TradeRequest,
	WorkWeek,
	Allowance,
	CheckIn,
	Info,
	BillingInfo,
	Invoice,
	ShiftType,
	Day,
	Team,
	Topic,
	Post,
	QuizItem,
	Environment,
	SkillSet,
	EmploymentType,
	UserEmploymentType,
	UserTemplateWeek,
	BillingActivity,
}
